import React from 'react';
import WithDriverIconPopup from '../WithDriverIconPopup';

function DriverRestBreakMarker({ backgroundColor, borderColor }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_3950_615)">
        <path
          d="M28 12C28 5.37258 22.6274 0 16 0C9.37258 0 4 5.37258 4 12C4 18.6274 9.37258 24 16 24C22.6274 24 28 18.6274 28 12Z"
          fill={backgroundColor}
        />
        <path
          d="M16 1C22.07 1 27 5.93 27 12C27 18.07 22.07 23 16 23C9.93 23 5 18.07 5 12C5 5.93 9.93 1 16 1ZM16 0C9.37 0 4 5.37 4 12C4 18.63 9.37 24 16 24C22.63 24 28 18.63 28 12C28 5.37 22.63 0 16 0Z"
          fill={borderColor}
          fillOpacity="0.87"
        />
        <path
          d="M12.24 6.85008C11.57 6.37008 11.4 5.44008 11.87 4.76008C12.34 4.08008 13.28 3.92008 13.96 4.39008C14.63 4.87008 14.8 5.80008 14.33 6.48008C13.85 7.16008 12.92 7.32008 12.24 6.85008ZM20.23 16.8701H14.93C13.82 16.8701 12.88 16.0601 12.71 14.9601L11.23 7.87008H9.72998L11.22 15.1901C11.51 17.0201 13.08 18.3701 14.93 18.3701H20.22V16.8701H20.23ZM20.4 13.8701H16.74L15.97 10.8001C17.16 11.4701 18.43 11.9601 19.83 11.7201V10.1201C18.61 10.3501 17.25 9.92008 16.31 9.18008L15.08 8.23008C14.91 8.09008 14.71 8.00008 14.51 7.94008C14.27 7.87008 14.01 7.85008 13.77 7.90008H13.75C12.83 8.07008 12.21 8.94008 12.37 9.86008L13.38 14.3001C13.59 15.3701 14.51 16.1301 15.59 16.1301H20.73L22.64 17.6301L23.76 16.5101L20.39 13.8901L20.4 13.8701Z"
          fill={borderColor}
          fillOpacity="0.87"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3950_615"
          x="0"
          y="0"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity ="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3950_615" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3950_615"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default WithDriverIconPopup(DriverRestBreakMarker);
